// extracted by mini-css-extract-plugin
export default {"container":"DurationSwitcher_container__+yLBP","active":"DurationSwitcher_active__e5NcL"};